export const socialsData = {
  github: "https://github.com/ithink24",
  facebook: "https://www.facebook.com/ankit.rajpoot.750546",
  linkedIn: "https://www.linkedin.com/in/ankit2401/",
  instagram: "https://www.instagram.com/_geekysloth/",
};
